module.exports = __webpack_public_path__ + "static/img/profile2.8a16f829.jpg";